/**
 * Creates a raw ActionCable subscription that is independent of the
 * actioncable-vue singleton-keyed channel registry.
 *
 * Use this when you need multiple concurrent subscriptions to the same
 * channel name (e.g., different story IDs) or when the actioncable-vue
 * lifecycle doesn't match your component lifecycle.
 *
 * @param {Vue} vm - A Vue component instance (must have `this.$cable` available)
 * @param {Object} channelParams - The params hash passed to ActionCable
 *   (must include `channel`, plus any additional identifiers)
 * @param {Object} callbacks - ActionCable subscription callbacks
 *   (`received`, `connected`, `disconnected`, `rejected`)
 * @returns {Object} The raw ActionCable subscription object (call `.unsubscribe()` to tear down)
 */
export function createRawSubscription(vm, channelParams, callbacks = {}) {
  const consumer = vm.$cable._cable

  if (!consumer) {
    throw new Error('ActionCable consumer is not available. Is actioncable-vue installed and connected?')
  }

  return consumer.subscriptions.create(channelParams, callbacks)
}
